<div class="modal-header">
  <h4 class="modal-title">
    {{ "campaignDetails.updateAdvertisingCampaign" | translate }} {{ ad.title }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row" *ngIf="ad.objectiveName == objectiveEnum.WEB_SITE_TRAFFIC">
      <div class="col">
        <div class="mb-3">
          <label class="form-label label" for="exampleFormControlText">
            {{ "campaignDetails.redirectionLink" | translate }} *
          </label>
          <input
            class="form-control"
            id="exampleFormControlText"
            type="text"
            [placeholder]="'campaignDetails.placeholderRedirection' | translate"
            formControlName="redirectionLink"
            required
          />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="ad.objectiveName == objectiveEnum.GENERATION_DE_PROSPECTS">
      <div class="col">
        <div class="mb-3">
          <label class="form-label label" for="exampleFormControlText">
            {{ "campaignDetails.formId" | translate }}
          </label>
          <input
            class="form-control"
            id="exampleFormControlText"
            type="text"
            [placeholder]="'campaignDetails.placeholderFormId' | translate"
            formControlName="formId"
          />
        </div>
      </div>
    </div>
    <div class="col mb-3">
      <div class="form-group">
        <label class="col-form-label label" for="Start Date">
          {{ "campaignDetails.startDate" | translate }} *
        </label>
        <div class="input-group">
          <div
            class="input-group date"
            id="dt-date"
            data-target-input="nearest"
          >
            <input
              class="form-control datetimepicker-input digits"
              type="text"
              [owlDateTime]="dt1"
              formControlName="startDate"
              [max]="endDate"
              [min]="minStartDate()"
              placeholder="yyyy-mm-dd"
              (ngModelChange)="
                onChangeStartDateCheckAvailability(); isModalOpen = true
              "
            />
            <div
              class="input-group-text bg-primary"
              data-target="#dt-date"
              [owlDateTimeTrigger]="dt1"
            >
              <i
                class="icofont icofont-ui-calendar"
                style="color: white; font-size: 12px"
              ></i>
            </div>
          </div>
          <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>
      </div>
    </div>
    <div class="col mb-3">
      <div class="form-group">
        <label class="col-form-label label" for="Start Date">
          {{ "campaignDetails.endDate" | translate }} *
        </label>
        <div class="input-group">
          <div
            class="input-group date"
            id="dt-date"
            data-target-input="nearest"
          >
            <input
              class="form-control datetimepicker-input digits"
              type="text"
              [owlDateTime]="dt"
              [min]="startDate"
              formControlName="endDate"
              readonly
              placeholder="yyyy-mm-dd"
              (ngModelChange)="onChangeCheckAvailability(); isModalOpen = true"
            />
            <div
              class="input-group-text bg-primary"
              data-target="#dt-date"
              [owlDateTimeTrigger]="dt"
            >
              <i
                class="icofont icofont-ui-calendar"
                style="color: white; font-size: 12px"
              ></i>
            </div>
          </div>
          <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
        </div>
      </div>
    </div>
    <div class="col mb-3">
      <div class="form-group">
        <label class="label"
          >{{ "campaignDetails.locations" | translate }} *</label
        >
        <div
          class="d-flex align-items-baseline txt-danger"
          *ngIf="isShowWarning()"
        >
          <i class="icofont icofont-info-circle m-r-5"></i>
          <p class="text-small">
            {{ "updateAvailability.locationAvailabilityWarning" | translate }}
          </p>
        </div>
        <app-select-locations-with-availabilities
          [ad]="ad"
          [endDate]="endDate"
          [startDate]="startDate"
          [totalPricePerDay]="totalPricePerDay"
          (emitLocationWithAvailabilities)="newAvailabilities($event)"
          [locationsWithAvailabilities]="locationsWithAvailabilities"
          [getLocationWithAvailabilities$]="emitLocationWithAvailabilities"
          (updatedLocationWithAvailability)="
            latestLocationWithAvailability($event)
          "
        ></app-select-locations-with-availabilities>
      </div>
    </div>
    <div class="col mb-3">
      <label class="label">{{ "addCampaign.video" | translate }}</label>
      <div class="m-b-10" *ngIf="showProgress">
        <ngb-progressbar [value]="uploadProgress"
          >{{ uploadProgress }}%</ngb-progressbar
        >
      </div>
      <ngx-dropzone
        [multiple]="false"
        (change)="onSelect($event.addedFiles)"
        accept="video/*"
      >
        <ngx-dropzone-label>
          <div>
            <div class="dz-message needsclick">
              <i class="icon-cloud-up"></i>
              <p style="color: black">{{ "dropzoneFile.title" | translate }}</p>
              <p class="dz-message needsclick" style="color: black">
                {{ "dropzoneFile.rulePart1" | translate }}
                <strong [ngClass]="{ 'txt-danger': showError }"
                  >{{ "dropzoneFile.rulePart2" | translate }} 5MB</strong
                >
              </p>
            </div>
          </div>
        </ngx-dropzone-label>
        <ngx-dropzone-preview
          *ngFor="let f of files"
          [file]="f"
          [removable]="true"
          (removed)="onRemove()"
        >
          <ngx-dropzone-label style="align-self: flex-end; margin: 0">
            <div class="ligne-top"></div>
            <div class="new-dropdown-label">
              {{ f.name.split(".")[0] | castFileName }} .{{
                f.type.split("/")[1]
              }}
            </div>
          </ngx-dropzone-label>
        </ngx-dropzone-preview>
      </ngx-dropzone>
    </div>
    <div class="checkbox-animated">
      <label class="d-block" for="checkbox">
        <input
          onkeypress
          class="checkbox_animated"
          id="checkbox"
          type="checkbox"
          style="margin-left: 0; margin-bottom: 7px"
          (click)="onChecked($event)"
        />
        {{ "updateTotalHT" | translate }}
      </label>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    data-bs-dismiss="modal"
    (click)="close()"
  >
    {{ "buttons.close" | translate }}
  </button>
  <button
    class="btn btn-primary"
    (click)="update()"
    [disabled]="!form.valid"
  >
    <loading-button
      [loading]="loading"
      [value]="'buttons.confirm'"
      [icon]="null"
    ></loading-button>
  </button>
</div>
